module.exports = __webpack_public_path__ + "static/IMG_3461-febf854d6c752678a9ea7fb4f15ddf4a.jpeg";